module.exports = __webpack_public_path__ + "static/media/greenBackground.3e55bcbf.jpg";